import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import "./App.css";

import Header from "./Header";
import Footer from "./Footer";

class Portfolio extends Component {
  render() {
    return (
      <div className="PortfolioApp">
        <Header white />
        <div className="portfolio-container">
          <div className="portfolio-spacer">
            <br />
            <br />
            <br />
            <br />
            <br />
          </div>
          <div>
            <Container>
              <Row>
                <Col xs="12">
                  <div className="portfolio-legend">
                    Past and Present Investments
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="portfolio-logo-container">
                    <a className="portfolio-logo" href="https://ancestry.com/">
                      <div
                        className="portfolio-logo portfolio-logo-ancestry"
                        title="ancestry"
                      />
                    </a>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="portfolio-logo-container">
                    <a className="portfolio-logo" href="https://arrivedo.com/">
                      <div
                        className="portfolio-logo portfolio-logo-arrivedo"
                        title="arrivedo"
                      />
                    </a>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="portfolio-logo-container">
                    <a className="portfolio-logo" href="https://blazingdb.com/">
                      <div
                        className="portfolio-logo portfolio-logo-blazing"
                        title="blazingdb"
                      />
                    </a>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="portfolio-logo-container">
                    <a
                      className="portfolio-logo"
                      style={{ height: "120px" }}
                      href="https://clip.mx/"
                    >
                      <div
                        className="portfolio-logo portfolio-logo-clip"
                        title="clip"
                      />
                    </a>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="portfolio-logo-container">
                    <a
                      className="portfolio-logo"
                      href="http://www.convert.com/"
                    >
                      <div
                        className="portfolio-logo portfolio-logo-convert"
                        title="convert"
                      />
                    </a>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="portfolio-logo-container">
                    <a className="portfolio-logo" href="https://converus.com/">
                      <div
                        className="portfolio-logo portfolio-logo-converus"
                        title="converus"
                      />
                    </a>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="portfolio-logo-container">
                    <a className="portfolio-logo" href="https://www.culqi.com/">
                      <div
                        className="portfolio-logo portfolio-logo-culqi"
                        title="culqi"
                      />
                    </a>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="portfolio-logo-container">
                    <a
                      className="portfolio-logo"
                      style={{ height: "120px" }}
                      href="https://carta.dilooapp.com/"
                    >
                      <div
                        className="portfolio-logo portfolio-logo-diloo"
                        title="diloo"
                      />
                    </a>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="portfolio-logo-container">
                    <a className="portfolio-logo" href="https://juntoz.com/">
                      <div
                        className="portfolio-logo portfolio-logo-juntoz"
                        title="juntoz"
                      />
                    </a>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="portfolio-logo-container">
                    <a
                      className="portfolio-logo"
                      style={{ height: "80px" }}
                      href="https://www.kubofinanciero.com/"
                    >
                      <div
                        className="portfolio-logo portfolio-logo-kubo"
                        title="kubo financiero"
                      />
                    </a>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="portfolio-logo-container">
                    <a
                      className="portfolio-logo"
                      href="https://www.ivanti.com/company/history/landesk"
                    >
                      <div
                        className="portfolio-logo portfolio-logo-landesk"
                        title="LANDESK"
                      />
                    </a>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="portfolio-logo-container">
                    <a
                      className="portfolio-logo"
                      style={{ height: "80px" }}
                      href="https://www.mfm.com.mx/"
                    >
                      <div
                        className="portfolio-logo portfolio-logo-mfm"
                        title="mfm"
                      />
                    </a>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="portfolio-logo-container">
                    <a className="portfolio-logo" href="https://mural.co/">
                      <div
                        className="portfolio-logo portfolio-logo-mural"
                        title="mural"
                      />
                    </a>
                  </div>
                </Col>

                <Col xs="6" sm="4">
                  <div className="portfolio-logo-container">
                    <a
                      className="portfolio-logo"
                      href="https://www.paykii.com/"
                    >
                      <div
                        className="portfolio-logo portfolio-logo-paykii"
                        title="Paykii"
                      />
                    </a>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="portfolio-logo-container">
                    <a
                      className="portfolio-logo"
                      href="http://rms.rhomobile.com/"
                    >
                      <div
                        className="portfolio-logo portfolio-logo-rhomobile"
                        title="RhoMobile"
                      />
                    </a>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="portfolio-logo-container">
                    <a
                      className="portfolio-logo"
                      href="https://www.sendmi.com/"
                    >
                      <div
                        className="portfolio-logo portfolio-logo-sendmi"
                        title="Sendmi"
                      />
                    </a>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="portfolio-logo-container">
                    <a
                      className="portfolio-logo"
                      style={{ height: "120px" }}
                      href="https://www.spacemonkey.com/"
                    >
                      <div
                        className="portfolio-logo portfolio-logo-spacemonkey"
                        title="Space Monkey"
                      />
                    </a>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="portfolio-logo-container">
                    <a
                      className="portfolio-logo"
                      style={{ height: "300px" }}
                      href="https://www.technisys.com/"
                    >
                      <div
                        className="portfolio-logo portfolio-logo-technisys"
                        title="technisys"
                      />
                    </a>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="portfolio-logo-container">
                    <a className="portfolio-logo" href="https://www.twenty.co/">
                      <div
                        className="portfolio-logo portfolio-logo-twenty"
                        title="Twenty"
                      />
                    </a>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="portfolio-logo-container">
                    <a
                      className="portfolio-logo"
                      href="https://www.vidangel.com/"
                    >
                      <div
                        className="portfolio-logo portfolio-logo-vidangel"
                        title="VidAngel"
                      />
                    </a>
                  </div>
                </Col>
                <Col xs="6" sm="4">
                  <div className="portfolio-logo-container">
                    <a
                      className="portfolio-logo"
                      style={{ width: "200px", maxWidth: "200px" }}
                      href="https://www.wanderu.com/en-us/"
                    >
                      {/* <a className="portfolio-logo" style={{width: '200px', maxWidth: '200px'}} href="https://www.wanderu.com/en-us/"> */}
                      <div
                        className="portfolio-logo portfolio-logo-wanderu"
                        title="wanderu"
                      />
                    </a>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        <div className="portfolio-spacer">
          <br />
          <br />
        </div>
        <Footer />
      </div>
    );
  }
}

export default Portfolio;



// WEBPACK FOOTER //
// ./src/Portfolio.js